import fetcher from '@/services/fetcher'
import { buildQueryV2 } from '@/utils/helpers'
import { DetailBlog, IReelResopnse } from '../types'
import appConfig from '@/config/global-config'
const GET_REELS = `
query getListReel($page_size: Int, $current_page: Int) {
  getListReel(page_size: $page_size, current_page: $current_page) {
    current_page
    items {
      author_avatar
      author_name
      content
      gallery
      thumbnail
      title
      type
      video_reel_url
      total_view
    }
    page_size
    total
  }
}
`
const BLOG_DETAIL = `
query getBlogPostGetByUrlKey($urlKey:String!){
  mpBlogPostGetByUrlKey(urlKey:$urlKey) {
    created_at
    enabled
    image
    name
    post_content
    author_name
    post_id
    publish_date
    url_key
    short_description
    store_ids
    updated_at
    album_images {
      alt
      image
    }
  }}

`
export const getReels = async ({ pageSize, currentPage }: { pageSize: number; currentPage: number }) => {
  try {
    const reels = await fetcher.get(
      buildQueryV2(GET_REELS, { page_size: pageSize, current_page: currentPage }),
      {
        next: { tags: ['reels'], revalidate: 60 },
        cache: 'force-cache',
      }
    )
    return reels?.payload?.data?.getListReel as IReelResopnse
  } catch (error) {
    console.error('Error fetching reels:', error)
    return null
  }
}
export const getBlogDetail = async ({ urlKey, locale }: { urlKey: string; locale?: string }) => {
  try {
    const blog = await fetcher.get(buildQueryV2(BLOG_DETAIL, { urlKey: urlKey }), {
      next: { tags: ['blog-detail', urlKey], revalidate: 180 },
      cache: 'force-cache',
      locale: locale || appConfig.defaultLocale,
    })
    return blog?.payload?.data?.mpBlogPostGetByUrlKey as DetailBlog
  } catch (error) {
    console.error('Error fetching blog detail:', error)
    return null
  }
}
